/* eslint-disable no-restricted-imports -- this module IS the sanctioned dayjs entry point */
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

/**
 * The app's single dayjs instance.
 *
 * Plugins are global mutable state: registering them per-file means behaviour
 * depends on import order, which produces bugs that only appear in production
 * bundles. ESLint bans importing `dayjs` anywhere else — import this instead.
 */
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

/**
 * Display formats. Use these instead of inlining format strings at call sites.
 *
 * Times are 12-hour with a lowercase meridiem throughout — the audience is
 * Australian, where 24-hour clock time reads as military or European.
 */
export const DATE_FORMAT = {
  /** 04 Mar 2026 */
  date: 'DD MMM YYYY',
  /** 04 Mar 2026, 2:30 pm */
  dateTime: 'DD MMM YYYY, h:mm a',
  /** 2:30 pm */
  time: 'h:mm a',
  /** Machine-readable, for API payloads and query params. */
  iso: 'YYYY-MM-DD',
} as const;

export { dayjs };
export type { Dayjs } from 'dayjs';
